import { CommonModule } from '@angular/common';
import { Component, inject, signal, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-image-preview-dialog',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './image-preview-dialog.html',
  styleUrl: './image-preview-dialog.scss',
})
export class ImagePreviewDialog implements OnInit {
  private _config: DynamicDialogConfig<{ imageUri: string }> = inject(DynamicDialogConfig);

  imageUri = signal<string>('');
  imageError = signal<boolean>(false);

  ngOnInit() {
    const uri = this._config.data?.imageUri ?? '';
    this.imageUri.set(uri);
  }

  onImageError(_event: Event) {
    console.error('Image failed to load in preview dialog');
    this.imageError.set(true);
  }

  onImageLoad(_event: Event) {
    this.imageError.set(false);
  }
}
